import styled from 'styled-components';
import { TypographyStyles, colours, media, spacing } from '@storefront/lib-global/stylings';

export const Breadcrumb = styled.nav`
  > ol {
    display: flex;
    flex-wrap: wrap;
    gap: 0 ${spacing.XXXS};
    margin: 0;
    padding: 0;

    @media ${media.greaterThan('lg')} {
      gap: ${spacing.XS};
    }
  }
`;

export const Item = styled.li`
  height: 100%;
  list-style: none;
  text-transform: capitalize;
  ${TypographyStyles.Body.Tiny.Regular}

  a {
    color: ${colours.BLACK};
    text-decoration: none;
    &:hover,
    &:focus {
      text-decoration: underline;
    }
  }

  &:not(:last-child)::after {
    content: '|';
    display: inline-block;
    height: 11px;
    margin-left: ${spacing.XXXXS};

    @media ${media.greaterThan('lg')} {
      margin-left: ${spacing.XS};
    }
  }

  &:nth-last-child(2)::after {
    font-weight: 600;
  }

  &:last-child {
    ${TypographyStyles.Body.Tiny.SemiBold}
  }
`;
